import { useLocation } from "react-router-dom";
import { isGeneralNavMenuRoute } from "./general-nav-menu-routes";

export function useGeneralNavMenuVisible() {
  const { pathname } = useLocation();
  return isGeneralNavMenuRoute(pathname);
}
